function remove (list, value) {
  list.forEach((val, index) => {
    if (val === value) {
      list.splice(index, 1)
    }
  })
}
function contains (list, value) {
  return list.indexOf(value) !== -1
}

/**
 * 对象转url参数
 * @param {*} data
 * @param {*} isPrefix
 */
function queryParams (data, isPrefix = false) {
  let prefix = isPrefix ? '?' : ''
  let _result = []
  for (let key in data) {
    let value = data[key]
    // 去掉为空的参数
    if (['', undefined, null].includes(value)) {
      continue
    }
    if (value.constructor === Array || typeof (value) === 'object') {
      _result.push(key + '=')
    } else {
      _result.push(key + '=' + value)
    }
  }

  return _result.length ? prefix + _result.join('&') : ''
}
export default {
  remove,
  contains,
  queryParams
}



// WEBPACK FOOTER //
// ./src/common/CommUtls.js